module.exports = __webpack_public_path__ + "img/mountains-min.72e78501.png";